module.exports = __webpack_public_path__ + "img/info.5d4e82fc.svg";